import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { VesselVoyageHistory } from '../models/voyage-history'
import {
  BehaviorSubject,
  catchError,
  forkJoin,
  Observable,
  Subject,
  tap,
  throwError,
} from 'rxjs'
import { VesselVoyageHistoryFilter } from '../models/fueleu'
import {
  SaveVoyageDataPayload,
  VoyageHistoryPayload,
} from '../models/voyage-data-management'
import { ToastrService } from 'ngx-toastr'

@Injectable({
  providedIn: 'root',
})
export class FueleuDataManagementService {
  private _url: string = `${environment.apiUrl}/api/VesselVoyageDataManagement`
  refreshData: Subject<boolean> = new Subject<boolean>()
  refreshData$: Observable<boolean> = this.refreshData.asObservable()

  latestEuaPrice: BehaviorSubject<number | null> = new BehaviorSubject(null)
  latestEuaPrice$: Observable<number | null> =
    this.latestEuaPrice.asObservable()

  refreshVoyageHistories: Subject<boolean> = new Subject<boolean>()
  refreshVoyageHistories$: Observable<boolean> =
    this.refreshVoyageHistories.asObservable()

  constructor(private http: HttpClient, private toastService: ToastrService) {}

  parseVoyages(id: string, file: FormData): Observable<VesselVoyageHistory[]> {
    return this.http.post<VesselVoyageHistory[]>(
      this._url + '/ParseCompletedVoyagesFile?id=' + id,
      file
    )
  }

  saveCompletedVoyages(
    model: SaveVoyageDataPayload,
    calculationModel: any
  ): Observable<any> {
    return this.http.post<any>(this._url + '/SaveCompletedVoyages', model)
  }

  updateVoyage(params: VoyageHistoryPayload) {
    return this.http.put(this._url, params)
  }

  getVoyageHistories(model: VesselVoyageHistoryFilter): Observable<any> {
    return this.http.post<any>(this._url + '/List', model)
  }

  deleteVoyage(id: string) {
    return this.http.delete(this._url + '/' + id)
  }

  deleteVoyages(ids: string[], customerId: string) {
    const params = new HttpParams().set('customerId', customerId)
    return this.http.post(this._url + '/DeleteVoyages', ids, { params })
  }

  toggleLock(id: string) {
    const params = new HttpParams().set('id', id)
    return this.http.patch(`${this._url}/SwitchLock`, {}, { params }).pipe(
      catchError(err => {
        this.toastService.error(err)
        return throwError(() => new Error(err))
      })
    )
  }
}
